import styled from 'styled-components';

export const StyledToggleContainer = styled.div`
  position: relative;
  width: 44px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-shrink: 0;
`;
export const SwitchLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  width: 44px;
  height: 24px;
  border-radius: 100px;
  background-color: ${({ theme }) => theme.hover};
  border: 1px solid ${({ theme }) => theme.border};
  position: relative;
  overflow: hidden;
  transition: background-color 0.2s, border-color 0.2s;
`;

export const SwitchInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 1px;
  height: 1px;
  margin: 0;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  pointer-events: none;
  &:checked + ${SwitchLabel} {
    background: ${({ viewMode, theme }) =>
      viewMode
        ? theme.textFaint
        : theme.isDark
          ? theme.headerAccent
          : theme.success};
    border-color: ${({ viewMode, theme }) =>
      viewMode
        ? theme.textFaint
        : theme.isDark
          ? theme.headerAccent
          : theme.success};
  }
`;

export const SwitchButton = styled.span`
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  transition: 0.2s;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
  ${SwitchInput}:checked + ${SwitchLabel} & {
    left: calc(100% - 2px);
    transform: translateX(-100%);
  }
`;
